import { useEffect } from 'react';
import { getStoredTokens, isTokenExpired } from './tokenStorage';
import { refreshAccessToken } from './tokenManager';

/**
 * Background refresh: checks every 60s (and when the tab becomes visible) and
 * refreshes when expiry is within 90s, so an active user rarely hits a 401.
 */
export function useTokenRefresh(): void {
  useEffect(() => {
    const tick = async () => {
      if (!getStoredTokens()) return;
      if (isTokenExpired(90)) await refreshAccessToken();
    };
    const handle = window.setInterval(() => void tick(), 60_000);
    const onVisible = () => {
      if (document.visibilityState === 'visible') void tick();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.clearInterval(handle);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);
}
